import React from 'react'
import './TextInput.css'

export default ({ onChange }) => (
  <input
    type="text"
    onChange={onChange}
    className="textInput"
    placeholder="Label"
  />
)
